<div class="section" id="education">
    <div class="container cc-education">
        <div class="h4 text-center mb-4 title">Education</div>
        <div class="card">
            <div class="row">
                <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div class="card-body cc-education-header">
                        <p>2021-2022</p>
                    <div class="h5">Masters Degree</div>
                    </div>    
                </div>
                <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div class="card-body">
                        <div class="h4">Masters in Data Science</div>
                            <h4 class="category">Univeristy of North Texas</h4>
                            <ul>
                                <li> Univeristy of North Texas is one of the best public univeristy in Texas, United States </li>
                                    <li>Completed a Master's degree with a major in <b>Data Science</b>, gaining expertise in data analysis, machine learning, and advanced computational techniques.</li>
                            </ul>
                    </div>
                </div>
            </div>
        </div>
            <div class="card">
                <div class="row">
                    <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body cc-education-header">
                            <p>2015-2019</p>
                        <div class="h5">Bachelor Degree</div>
                        </div>    
                    </div>
                    <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body">
                            <div class="h4">Bachelor of Technology</div>
                                <h4 class="category">Nalla Malla Reddy Engineering College</h4>
                                <ul>
                                    <li> NMREC (Affilated to JNTUH) <b>ranks top 15</b> in Hyderabad, Telangana </li>
                                        <li>Graduated with a Bachelor's degree in <b>Electronics and Communication Engineering (ECE)</b>, building a solid foundation in technology and communication systems.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="card">
                <div class="row">
                    <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body cc-education-header">
                            <p>2013-2015</p>
                        <div class="h5">Intermdiate</div>
                        </div>    
                    </div>
                    <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body">
                            <div class="h4">Intermediate</div>
                            <h4 class="category">Narayana Jr College</h4>
                            <ul>
                                    <li>Completed  <b>Intermediate</b> in <b>MPC</b> with <b>94.5%</b> aggregate.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="card">
                <div class="row">
                    <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body cc-education-header">
                            <p>2009-2011</p>
                        <div class="h5">Industrial Training Institute</div>
                        </div>    
                    </div>
                    <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body">
                            <div class="h5">ITI(NCVT)</div>
                                <h4 class="category">GOVT ITI HASSAN</h4>
                                <ul>
                                        <li>Completed <b>ITI</b> in <b>Center of Excellence(COE)</b> with <b>80% </b>aggregate.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="card">
                <div class="row">
                    <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body cc-education-header">
                            <p>2012-2013</p>
                        <div class="h5">Sedcondary School</div>
                        </div>    
                    </div>
                    <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                        <div class="card-body">
                            <div class="h4">Secondary School(SSC)</div>
                                <h4 class="category">Cattamanchi Ramalinga Reddy High School</h4>
                                <ul>
                                    <li>Completed  SSC with <b>97%</b>.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>                                               